import React from "react";
import LogoImg from "../../../assets/Images/Logo.png";
import "./Logo.css";
import { Link } from "react-router-dom";

function Logo() {
  return (
    <div className="Logo">
      <Link to="/">
        <img src={LogoImg} alt="horse" />
      </Link>
    </div>
  );
}

export default Logo;
